var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0585 5.79248C17.5251 3.98415 16.0168 2.47582 14.2085 1.94248C12.8335 1.54248 11.8835 1.57582 11.2251 2.06748C10.4335 2.65915 10.3418 3.72582 10.3418 4.48415V6.55915C10.3418 8.60915 11.2751 9.65082 13.1085 9.65082H15.5001C16.2501 9.65082 17.3251 9.55915 17.9168 8.76748C18.4251 8.11748 18.4668 7.16748 18.0585 5.79248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7585 11.133C15.5418 10.883 15.2252 10.7413 14.9002 10.7413H11.9168C10.4502 10.7413 9.25849 9.54964 9.25849 8.08297V5.09964C9.25849 4.77464 9.11683 4.45797 8.86683 4.2413C8.62516 4.02464 8.29183 3.92464 7.97516 3.9663C6.01683 4.2163 4.21683 5.2913 3.04183 6.90797C1.85849 8.53297 1.42516 10.5163 1.80016 12.4996C2.34183 15.3663 4.63349 17.658 7.50849 18.1996C7.96683 18.2913 8.42516 18.333 8.88349 18.333C10.3918 18.333 11.8502 17.8663 13.0918 16.958C14.7085 15.783 15.7835 13.983 16.0335 12.0246C16.0752 11.6996 15.9752 11.3746 15.7585 11.133Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIconActive);
export default __webpack_public_path__ + "static/media/graph-icon-active.289b894302db20e5fedc4e2dcfbbcd24.svg";
export { ForwardRef as ReactComponent };